import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { CarrierService } from '../carrier.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Ceve } from 'src/app/ceq/common/models/Ceve.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-carrier-list',
  templateUrl: './carrier-list.component.html',
  styleUrls: ['./carrier-list.component.scss']
})
export class CarrierListComponent implements OnInit {
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  options: GridOptions;
  ceveList: Ceve[] = [];
  ceve: number;
  keyword = "CeveName";
  selectedUnit: string;
  userLogin: UserLogin;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    { headerName: 'Empleado', field: 'EmployeeCode', flex: 1, sortable: true, resizable: true },
    { headerName: 'Placa', field: 'LicensePlate', flex: 1, cellClass: 'text-center', sortable: true },
    { headerName: 'Modelo', field: 'ModelYear', width: 100, cellClass: 'text-center' },
    { headerName: 'Configuración', field: 'VehicleConfiguration', flex: 1.5 },
    { 
      headerName: 'Última modificación', 
      field: 'ModifiedAt', 
      flex: 1.2, 
      cellClass: 'text-center',
      cellRenderer: (params: any) => params.value ? moment(params.value).format('YYYY-MM-DD HH:mm') : '-' 
    },
    { headerName: 'Modificado por', field: 'ModifiedBy', flex: 1, cellClass: 'text-center' },
    { headerName: 'Editar', width: 80, cellRenderer: 'childEditRenderer', cellClass: 'text-center' },
    { headerName: 'Eliminar', width: 80, cellRenderer: 'childDeleteMessageRenderer', cellClass: 'text-center' }
  ];

  constructor(
    private globalFunctionService: GlobalFunctionsService,
    private settings: SettingsService,
    private carrierService: CarrierService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    this.ceve = this.userLogin.UnitId;
  }

  async refresh(){
    this.getCarriers();
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getCeveList();
  }

  async getCeveList() {
    try {
      const userlevels = await this.settings.getUserProfileLevels();
      if (!userlevels || userlevels.length === 0) return;

      // Filtrar y mapear CEVEs
      this.ceveList = userlevels
        .filter(x => x.LevelType === "CEVE")
        .map(unit => ({
          UnitId: unit.UnitId,
          CeveName: unit.UnitDescription
        } as Ceve))
        .sort((a, b) => a.CeveName.localeCompare(b.CeveName));

      // Selección inicial
      const currentCeve = this.ceveList.find(x => x.UnitId === this.ceve) || this.ceveList[0];
      if (currentCeve) {
        this.ceve = currentCeve.UnitId;
        this.selectedUnit = currentCeve.CeveName;
      }

      this.getCarriers();
    } catch (error) {
      console.error("Error cargando niveles de perfil", error);
    }
  }

  getCarriers() {
    if (this.ceve) {
      this.ceqGrid.endPoint = `carrier/unit/${this.ceve}`;
      this.ceqGrid.refreshTable();
    }
  }

  selectEvent(event: any) {
    this.ceve = event.UnitId;
    this.getCarriers();
  }

  cmbOutputCeve() {
    // Si se limpia el buscador, podrías resetear a la unidad por defecto o limpiar la tabla
  }

  btnAddClick() {
    window.open('/tax/carrier/create', '_blank');
  }

  edit(row: any) {
    window.open('/tax/carrier/' + row.data.EmployeeCode, '_blank');
  }

  async delete(row: any) {
    const confirm = await this.globalFunctionService.messageBimbo(
      `¿Desea eliminar el vehículo del empleado ${row.data.EmployeeCode}?`, 
      'question1', 
      'Confirmación'
    );

    if (confirm) {
      this.carrierService.deleteCarrier(row.data.EmployeeCode).subscribe({
        next: async () => {
          await this.globalFunctionService.messageBimbo('Vehículo eliminado correctamente.', 'success', '¡Éxito!');
          this.getCarriers();
        },
        error: async (err) => {
          await this.globalFunctionService.messageBimbo(err.error || 'Error al eliminar', 'error', '¡Error!');
        }
      });
    }
  }
}